export default [
    'ID',
    'Name',
    'Operator',
    'Well',
    'API 14',
    'OperatorKey',
    'Operator Number',
    'API No',
    'Well Name',
    'Incident',
    'Postal Code',
    'Lease'
]